import { useEffect } from 'react';
import { useInterval } from 'nike-ui/src/common/hooks/useInterval';
import { dispatch } from 'nike-re-framejs';
import { refreshMenu } from '@/nikeone/handlers';

function useRefreshMenu() {
    useEffect(() => {
        dispatch(refreshMenu(true));
    }, []);
    useInterval(() => () => dispatch(refreshMenu()), 60 * 1000);
}

export default useRefreshMenu;
